// source: src/common/organization/organization.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

goog.exportSymbol('proto.loupe.common.organization.Organization', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loupe.common.organization.Organization = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loupe.common.organization.Organization.repeatedFields_, null);
};
goog.inherits(proto.loupe.common.organization.Organization, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loupe.common.organization.Organization.displayName = 'proto.loupe.common.organization.Organization';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loupe.common.organization.Organization.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loupe.common.organization.Organization.prototype.toObject = function(opt_includeInstance) {
  return proto.loupe.common.organization.Organization.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loupe.common.organization.Organization} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.organization.Organization.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    timezone: jspb.Message.getFieldWithDefault(msg, 3, ""),
    fiscalYearStartMonth: jspb.Message.getFieldWithDefault(msg, 4, 0),
    salesPeriodLength: jspb.Message.getFieldWithDefault(msg, 5, 0),
    salesPeriodUnit: jspb.Message.getFieldWithDefault(msg, 6, ""),
    versionsList: jspb.Message.toObjectList(msg.getVersionsList(),
    proto.loupe.common.organization.Organization.toObject, includeInstance),
    isTestInstance: jspb.Message.getBooleanFieldWithDefault(msg, 8, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loupe.common.organization.Organization}
 */
proto.loupe.common.organization.Organization.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loupe.common.organization.Organization;
  return proto.loupe.common.organization.Organization.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loupe.common.organization.Organization} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loupe.common.organization.Organization}
 */
proto.loupe.common.organization.Organization.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimezone(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFiscalYearStartMonth(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSalesPeriodLength(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSalesPeriodUnit(value);
      break;
    case 7:
      var value = new proto.loupe.common.organization.Organization;
      reader.readMessage(value,proto.loupe.common.organization.Organization.deserializeBinaryFromReader);
      msg.addVersions(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsTestInstance(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loupe.common.organization.Organization.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loupe.common.organization.Organization.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loupe.common.organization.Organization} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.organization.Organization.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTimezone();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFiscalYearStartMonth();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getSalesPeriodLength();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getSalesPeriodUnit();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getVersionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.loupe.common.organization.Organization.serializeBinaryToWriter
    );
  }
  f = message.getIsTestInstance();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.loupe.common.organization.Organization.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.organization.Organization} returns this
 */
proto.loupe.common.organization.Organization.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.loupe.common.organization.Organization.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.organization.Organization} returns this
 */
proto.loupe.common.organization.Organization.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string timezone = 3;
 * @return {string}
 */
proto.loupe.common.organization.Organization.prototype.getTimezone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.organization.Organization} returns this
 */
proto.loupe.common.organization.Organization.prototype.setTimezone = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 fiscal_year_start_month = 4;
 * @return {number}
 */
proto.loupe.common.organization.Organization.prototype.getFiscalYearStartMonth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.loupe.common.organization.Organization} returns this
 */
proto.loupe.common.organization.Organization.prototype.setFiscalYearStartMonth = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 sales_period_length = 5;
 * @return {number}
 */
proto.loupe.common.organization.Organization.prototype.getSalesPeriodLength = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.loupe.common.organization.Organization} returns this
 */
proto.loupe.common.organization.Organization.prototype.setSalesPeriodLength = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string sales_period_unit = 6;
 * @return {string}
 */
proto.loupe.common.organization.Organization.prototype.getSalesPeriodUnit = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.organization.Organization} returns this
 */
proto.loupe.common.organization.Organization.prototype.setSalesPeriodUnit = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated Organization versions = 7;
 * @return {!Array<!proto.loupe.common.organization.Organization>}
 */
proto.loupe.common.organization.Organization.prototype.getVersionsList = function() {
  return /** @type{!Array<!proto.loupe.common.organization.Organization>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.loupe.common.organization.Organization, 7));
};


/**
 * @param {!Array<!proto.loupe.common.organization.Organization>} value
 * @return {!proto.loupe.common.organization.Organization} returns this
*/
proto.loupe.common.organization.Organization.prototype.setVersionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.loupe.common.organization.Organization=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loupe.common.organization.Organization}
 */
proto.loupe.common.organization.Organization.prototype.addVersions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.loupe.common.organization.Organization, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loupe.common.organization.Organization} returns this
 */
proto.loupe.common.organization.Organization.prototype.clearVersionsList = function() {
  return this.setVersionsList([]);
};


/**
 * optional bool is_test_instance = 8;
 * @return {boolean}
 */
proto.loupe.common.organization.Organization.prototype.getIsTestInstance = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.loupe.common.organization.Organization} returns this
 */
proto.loupe.common.organization.Organization.prototype.setIsTestInstance = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


goog.object.extend(exports, proto.loupe.common.organization);
